import React, { useEffect, useState } from 'react';
import { eventsAPI, unwrapList } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';

const MemberEvents = () => {
  const { t } = useLanguage();
  const [events, setEvents] = useState([]);
  const [mine, setMine] = useState([]);
  const [waiting, setWaiting] = useState([]);
  const [message, setMessage] = useState('');

  const load = async () => {
    const [eventRes, mineRes, waitRes] = await Promise.all([
      eventsAPI.getUpcoming(),
      eventsAPI.myRegistrations(),
      eventsAPI.myWaitlist(),
    ]);
    setEvents(unwrapList(eventRes.data));
    setMine(unwrapList(mineRes.data));
    setWaiting(unwrapList(waitRes.data));
  };

  useEffect(() => {
    load().catch(() => setMessage(t('member.loadFail')));
  }, []);

  const textFor = (code, fallback) => {
    if (!code) return fallback;
    const key = `desk.${code}`;
    const text = t(key);
    return text === key ? fallback : text;
  };

  const register = async (eventId) => {
    setMessage('');
    try {
      const response = await eventsAPI.register(eventId);
      setMessage(textFor(response.data.code, response.data.message || t('member.done')));
      load();
    } catch (error) {
      setMessage(textFor(error.response?.data?.code, error.response?.data?.error || t('member.registerFail')));
    }
  };

  const cancel = async (id) => {
    await eventsAPI.cancelRegistration(id);
    setMessage(t('member.cancelled'));
    load();
  };

  return (
    <div className="admin-page">
      <h1>{t('member.events')}</h1>
      {message && <p>{message}</p>}
      <section>
        <h2>{t('member.upcoming')}</h2>
        <ul className="pos-list">
          {events.map((event) => (
            <li key={event.id}>
              <strong>{event.title}</strong>
              <div>{event.location}</div>
              <button type="button" className="pos-btn" onClick={() => register(event.id)}>{t('member.register')}</button>
            </li>
          ))}
        </ul>
      </section>
      <section>
        <h2>{t('member.registered')}</h2>
        <ul className="pos-list">
          {mine.map((row) => (
            <li key={row.id}>
              {row.event_title || row.event?.title || t('member.eventFallback')} · {row.status}
              {row.status !== 'cancelled' && (
                <button type="button" className="pos-btn secondary" onClick={() => cancel(row.id)}>{t('member.cancel')}</button>
              )}
            </li>
          ))}
        </ul>
      </section>
      <section>
        <h2>{t('member.waitlist')}</h2>
        <ul className="pos-list">
          {waiting.map((row) => (
            <li key={row.id}>{row.title}</li>
          ))}
          {waiting.length === 0 && <li>{t('member.noWait')}</li>}
        </ul>
      </section>
    </div>
  );
};

export default MemberEvents;
